import React from 'react';

import { Container } from './styles';

function Content({ children }) {
  return <Container>{children}</Container>;
}

export default Content;
